import styled from 'styled-components';

export const ActionsWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 10px;
  justify-content: end;

  & > button {
    display: block;
    max-width: 160px;
  }
  & > button:last-of-type {
    position: relative;
    top: -1px;
  }
`;
